module.exports = __webpack_public_path__ + "media/newstyle/images/a4-9e6c09ee4c5be73087565559b384e8a2.svg";